import { globalEventBus } from '@fiverr-private/futile';
import { enrichEvents } from '../../helpers/enrichEvents';
import isDev from '../../../../helpers/isDev';
import logger from '../../../../logger/emitter';
import getInstanceEnrichment from './instanceEnrichment';
import * as API from './api';

/**
 * Listen to global event bus on BIG_QUERY events
 * @param  {String} options.host url to post events
 * @param  {String} [options.facility] helper added on each event
 * @param  {String} [options.mode] 'development' or not
 * @param  {String} [options.rootKey] rootKey for named array BigQuery API
 */
const registerBigQueryListener = ({ host, facility = '', mode = 'production', busEventName, rootKey } = {}) => {
    if (globalEventBus.has(busEventName)) {
        return;
    }

    const dev = isDev(mode);

    if (!dev && (!host || typeof host !== 'string')) {
        throw new TypeError(`Expected "host" to be a string. Instead got ${typeof host} (${host}).`);
    }

    if (!dev && !/^\/|^http/.test(host)) {
        throw new Error(`Expected "host" to be an absolute url (begin with http or slash). Instead got (${host}).`);
    }

    const enrichment = {
        facility,
        ...getInstanceEnrichment()
    };

    const action = dev
        ? ({ events }) => logger.info(`${busEventName} events:`, enrichEvents(events, enrichment))
        : ({ events }) => API.post(host, enrichEvents(events, enrichment), rootKey).catch((error) => {
            error.message = `${busEventName}: ${error.message}`;
            error.code = 'BIGQUERY_EVENT_ERR';
            logger.error(error);
        })
    ;

    globalEventBus.on(busEventName, action);
};

export default registerBigQueryListener;
